import { Button, Input, Select } from "antd";
import React, { useEffect, useState } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { useDispatch, useSelector } from "react-redux";
import { DialogBox } from "../../../components/dialog/DialogBox";
import {
  setIsPopUpShow,
  setPopUpTitle,
  setCloseBtnName,
  setSubmitBtnName,
} from "../../../redux/slices/popUpSlice";
import CommanTable from "../../../components/table/CommanTable";
import {
  getAllTemplates,
  createTemplate,
} from "../../../redux/slices/broadcastTemplateSlice";
import { FileTextOutlined, SearchOutlined } from "@ant-design/icons";
import { Space, Tag } from "antd";

const BroadcastTemplate = () => {
  const dispatch = useDispatch();
  const [filters, setFilters] = useState({
    name: null,
  });

  const [templateName, setTemplateName] = useState("");
  const [utility, setUtility] = useState();
  const [content, setContent] = useState("");
  const [buttonText, setButtonText] = useState("");
  const [buttonUrl, setButtonUrl] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const modules = {
    toolbar: [[]],
  };

  const formats = [];

  const handleClose = () => {
    dispatch(setIsPopUpShow(false));
  };

  const handleCreate = () => {
    if (submitting) return;
    setSubmitting(true);
    const payload = {
      name: templateName,
      category: (utility || "").toString().toUpperCase(),
      language: "en_US",
      bodyText: content,
      bodyExamples: [],
      buttons: [
        {
          type: "URL",
          text: buttonText,
          url: buttonUrl,
        },
      ],
    };
    dispatch(createTemplate({ body: payload }))
      .then(() => {
        dispatch(setIsPopUpShow(false));
        setTemplateName("");
        setUtility(undefined);
        setContent("");
        setButtonText("");
        setButtonUrl("");
        dispatch(getAllTemplates({ page: 1, limit: 10 }));
      })
      .finally(() => {
        setSubmitting(false);
      });
  };

  const renderCreateTemplateUI = () => (
    <div style={{ paddingBottom: 50 }}>
      <div style={{ marginBottom: 12 }}>
        <label style={{ display: "block", fontWeight: "bold" }}>Name</label>
        <Input
          placeholder="Enter template name (e.g., test_test)"
          value={templateName}
          onChange={(e) => setTemplateName(e.target.value)}
        />
      </div>
      <div style={{ marginBottom: 12 }}>
        <label
          style={{ display: "block", fontWeight: "bold", marginBottom: 6 }}
        >
          Type
        </label>
        <Select
          placeholder="Select utility"
          value={utility}
          onChange={(val) => setUtility(val)}
          style={{ width: "100%" }}
          options={[
            { value: "utility", label: "Utility" },
            { value: "marketing", label: "Marketing" },
          ]}
        />
      </div>
      <div style={{ marginBottom: 12 }}>
        <label
          style={{ display: "block", fontWeight: "bold", marginBottom: 6 }}
        >
          Button Text
        </label>
        <Input
          placeholder="Enter button text"
          value={buttonText}
          onChange={(e) => setButtonText(e.target.value)}
        />
      </div>
      <div style={{ marginBottom: 12 }}>
        <label
          style={{ display: "block", fontWeight: "bold", marginBottom: 6 }}
        >
          Button Link
        </label>
        <Input
          placeholder="Enter button link URL"
          value={buttonUrl}
          onChange={(e) => setButtonUrl(e.target.value)}
        />
      </div>
      <div>
        <label style={{ display: "block", marginBottom: 6 }}>Content</label>
        <ReactQuill
          theme="snow"
          value={content}
          onChange={setContent}
          style={{ height: 220 }}
          modules={modules}
          formats={formats}
        />
      </div>
    </div>
  );

  const customFooter = () => (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <Button onClick={handleClose}>Cancel</Button>
      <Button
        type="primary"
        onClick={handleCreate}
        loading={submitting}
        disabled={submitting}
      >
        Create
      </Button>
    </div>
  );

  const { templates, loading } = useSelector(
    (state) => state.broadcastTemplateReducer || {},
  );
  const { page, limit } = useSelector((state) => state.globalReducer);

  const [visibleColumns, setVisibleColumns] = useState({
    name: true,
    language: false,
    status: true,
    category: true,
  });

  const dataSource = templates?.map((t) => ({
    key: t.id || t._id,
    name: t.name,
    bodyText: t.bodyText,
    status: t.status
      ? t.status.charAt(0).toUpperCase() + t.status.slice(1).toLowerCase()
      : "",
    category: t.category
      ? t.category.charAt(0).toUpperCase() + t.category.slice(1).toLowerCase()
      : "",
  }));
  const handleApiCall = (page, limit, searchKey = "") => {
    dispatch(getAllTemplates({ page, limit, name: searchKey }));
  };
  useEffect(() => {
    handleApiCall(page, limit);
  }, []);

  // const handleSearch = (selectedKeys, confirm, dataIndex) => {
  //   console.log("selectedKeys", selectedKeys)
  //   console.log("dataIndex", dataIndex)
  //   confirm();
  //   const newFilters = {
  //     ...filters,
  //     [dataIndex]: selectedKeys[0] || null,
  //   };
  //   setFilters(newFilters);
  //   handleApiCall(1, limit);
  // };

  // const handleReset = (dataIndex, clearFilters, confirm) => {
  //   const newFilters = {
  //     ...filters,
  //     [dataIndex]: null,
  //   };
  //   setFilters(newFilters);

  //   if (clearFilters) {
  //     clearFilters();
  //   }

  //   if (confirm) {
  //     confirm();
  //   }
  //   handleApiCall(1, limit);
  // };
  // Initial fetch is triggered by CommanTable's internal effect
  return (
    <>
      <CommanTable
        title="Template"
        icon={<FileTextOutlined className="icon-size text-white" />}
        data={dataSource}
        loading={loading}
        visibleColumns={visibleColumns}
        setVisibleColumns={setVisibleColumns}
        apiCall={handleApiCall}
        actionsOptions={[]}
        // customColumns={[
        //   {
        //     title: "Name",
        //     dataIndex: "name",
        //     key: "name",
        //     filteredValue: filters.name ? [filters.name] : null,
        //     filterIcon: (filtered) => (
        //       <SearchOutlined
        //         style={{ color: filtered ? "#1890ff" : "#666666" }}
        //       />
        //     ),
        //     filterDropdown: ({
        //       setSelectedKeys,
        //       selectedKeys,
        //       confirm,
        //       clearFilters,
        //     }) => (
        //       <div style={{ padding: 8 }}>
        //         <Input
        //           placeholder="Search name"
        //           value={selectedKeys[0]}
        //           onChange={(e) =>
        //             setSelectedKeys(e.target.value ? [e.target.value] : [])
        //           }
        //           onPressEnter={() => {
        //             // confirm();
        //             handleSearch(selectedKeys, confirm, "name");
        //           }}
        //           style={{ width: 188, marginBottom: 8, display: "block" }}
        //         />
        //         <Space>
        //           <Button
        //             type="primary"
        //             onClick={() => {
        //               // confirm();
        //               handleSearch(selectedKeys, confirm, "name");
        //             }}
        //             size="small"
        //             style={{ width: 90 }}
        //           >
        //             Search
        //           </Button>
        //           <Button
        //             onClick={() => handleReset("name", clearFilters, confirm)}
        //             size="small"
        //             style={{ width: 90 }}
        //           >
        //             Reset
        //           </Button>
        //         </Space>
        //       </div>
        //     ),
        //     onFilter: (value, record) =>
        //       record.name.toLowerCase().includes(value.toLowerCase()),
        //   },
        //   { title: "Message", dataIndex: "bodyText", key: "bodyText" },
        //   {
        //     title: "Status",
        //     dataIndex: "status",
        //     key: "status",
        //     render: (text) => (
        //       <Tag color={text == "Approved" ? "green" : "orange"}>{text}</Tag>
        //     ),
        //   },
        // ]}
        showColumnDropdown={false}
      />
      <DialogBox
        isFooter={true}
        customFooter={customFooter}
        renderUi={renderCreateTemplateUI}
        onClose={handleClose}
      />
    </>
  );
};

export default BroadcastTemplate;
